<template>
  <div class="mb-3">
    <label :for="inputID" class="form-label">{{ label }}</label>
    <v-otp-input
      class="otp-container"
      ref="otpInput"
      v-model:value="bindModal"
      input-classes="otp-input"
      separator="-"
      :num-inputs="length"
      :should-auto-focus="true"
      input-type="number"
      :required="required"
      :is-disabled="isDisabled"
      @on-change="update"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import VOtpInput from "vue3-otp-input";

export default defineComponent({
  name: "OtpInput",
  components: { VOtpInput },

  setup() {
    const bindModal = ref("");

    return { bindModal };
  },

  emits: ["onUpdate"],

  props: {
    length: {
      required: true,
      type: Number,
    },
    required: {
      required: false,
      type: Boolean,
    },
    label: {
      required: true,
      type: String,
    },
    inputID: {
      required: true,
      type: String,
    },
    isDisabled: {
      type: Boolean,
    },
  },
  methods: {
    update(value: string) {
      console.log(value);
      this.$emit("onUpdate", this.inputID, value);
    },
  },
});
</script>

<style>
.otp-input {
  width: 40px;
  height: 40px;
  padding: 5px;
  margin: 0 10px;
  font-size: 20px;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  text-align: center;
}

.otp-container {
  justify-content: center;
}

/* Background colour of an input field with value */
.otp-input.is-complete {
  border-width: 2px;
  border-color: rgba(0, 0, 0, 0.5);
}

.otp-input::-webkit-inner-spin-button,
.otp-input::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
</style>
